import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Table } from "antd";
const ConsignmentReusablePackagingTable = ({ reusablePackagings, hasActions, renderActions }) => {
    const columns = [{
            title: 'Packaging',
            dataIndex: ['reusablePackaging', 'name'],
            width: '20%'
        }, {
            title: 'Deliver',
            key: "drop",
            width: '20%',
            children: [{
                    title: 'Scheduled',
                    dataIndex: 'scheduledDropQuantity'
                }, {
                    title: 'Actual',
                    dataIndex: 'actualDropQuantity'
                }]
        }, {
            title: 'Return',
            key: "pickup",
            width: '20%',
            children: [{
                    title: 'Scheduled',
                    dataIndex: 'scheduledPickupQuantity'
                }, {
                    title: 'Actual',
                    dataIndex: 'actualPickupQuantity'
                }]
        }, {
            title: 'Return Location',
            dataIndex: ['returnToSenderReceiver', 'companyName'],
            width: '20%'
        }];
    if (hasActions && renderActions) {
        columns.push({
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text, record, index) => {
                return renderActions(record, index);
            }
        });
    }
    return (_jsx(Table, { columns: columns, size: "middle", rowKey: record => record.id, dataSource: reusablePackagings, loading: false, pagination: false, scroll: { x: 600 } }));
};
export default ConsignmentReusablePackagingTable;
